import React from 'react'
import { styled } from '../../stitches.config'

import SwitchText from './SwitchText'

const BridVoteButton = ({ articleID, percentage = {}, voted, hasCookie = false, ...props }) => {

    return (<BoxWrapper
        type="button"
        disabled={voted !== null || hasCookie}
        onClick={() => props.fetchVotes(articleID)}>
        <Title>
            {props.title_normal}
        </Title>
        {hasCookie
            ? <p>{props.votingResult[articleID]}% głosów</p>
            : <>
                {voted === null
                    ? <p>Oddaj głos</p>
                    : <SwitchText
                        firstText={voted == articleID && 'Dziękujemy za oddany głos!'}
                        secondText={`${percentage[articleID]}% głosów`}
                        render={data => (<p>{data}</p>)}
                    />}
            </>}
    </BoxWrapper>)
}

const BoxWrapper = styled("button", {
    border: "none",
    textAlign: "left",
    padding: "0",
    display: "block",
    backgroundColor: "#fff",
    margin: "0 0 10px 0",
    height: "100px",
    width: "100%",
    "p": {
        width: "auto",
        height: "18px",
        fontSize: "14px",
        lineHeight: 1.29,
        letterSpacing: "-0.4px",
        margin: "12px 16px",
        color: "$primary"
    },
    "&:hover": {
        cursor: "pointer"
    },
    "&:disabled": {
        cursor: "default"
    },
    "@media (min-width: 992px)": {
        width: "220px",
        maxWidth: "30%",
        margin: "0 20px 0 0 !important",
        "p": {
            width: "183px",
            margin: "0 18px 12px 16px"
        }
    }
});

const Title = styled("span", {
    display: "block",
    width: "183px",
    fontSize: "15px",
    color: "#272424",
    margin: "13px 21px 3px 16px",
    lineHeight: 1.1,
    transition: "color 300ms",
    "&:hover": {
        color: "#737373"
    }
});

export default BridVoteButton